import { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const AccordionContext = createContext();

/**
 * Use AccordionProvider to create a AccordionContext for AccordionPanels.
 * When AccordionPanels is wrapped inside a AccordionProvider only one AccordionPanel will be open at a time.
 *
 * @param {node} children
 * @param {string[]} initialState - Contains the name-prop of all open AccordionPanels.
 */

const AccordionProvider = ({ children, initialState }) => {
    const [state, update] = useState(initialState);

    const open = name => update([name]);
    const close = name => update(state.filter(v => v !== name));
    const contains = name => state.indexOf(name) !== -1;
    const toggle = name => (contains(name) ? close(name) : open(name));

    return (
        <AccordionContext.Provider value={{ state, open, close, toggle, contains }}>
            {children}
        </AccordionContext.Provider>
    );
};

AccordionProvider.propTypes = {
    children: PropTypes.node,
    initialState: PropTypes.arrayOf(PropTypes.string),
};

AccordionProvider.defaultProps = {
    initialState: [],
};

export default AccordionProvider;

/**
 * Example usage:

	<AccordionProvider>
		<AccordionPanel
			name="SizeSelector"
			label="Select size"
			render={({ toggleAccordion, setAccordionLabel }) => (
				<div onClick={() => {
					toggleAccordion();
					setAccordionLabel('Selected size');
				}}>
					Content for this AccordionPanel.
				</div>
			)}
		/>
		<AccordionPanel
			lastChild
			name="ColorSelector"
			label="Select color"
			render={({ toggleAccordion, setAccordionLabel }) => (
				<div onClick={() => {
					toggleAccordion();
					setAccordionLabel('Selected color');
				}}>
					Content for this AccordionPanel.
				</div>
			)}
		/>
	</AccordionProvider>

 */
